import { http, results } from './client';

const seg = (value) => encodeURIComponent(String(value));
const withAuth = (path, signedIn) => (signedIn ? `${path}/auth` : path);

/*
 * Step 1 of the online-payment flows. Each returns
 *   { booking_number, client_secret, payment_intent_id, amount, currency }
 * `amount` is what Stripe will charge.
 */

/** Self-hosted rooms (booking numbers "SH-…"). */
export const createSelfHostIntent = (payload, { signedIn = false } = {}) =>
  http.post(withAuth('api/v1/payments/create-booking-intent', signedIn), payload).then(results);

/** Hotels-by-day partner rates paid online ("HBD-…"). */
export const createHbdIntent = (payload, { signedIn = false } = {}) =>
  http.post(withAuth('api/v1/payments/hbd-booking-intent', signedIn), payload).then(results);

/** Brevistay partner rates paid online ("BRV-…"). */
export const createBrevistayIntent = (payload, { signedIn = false } = {}) =>
  http.post(withAuth('api/v1/payments/brevistay-booking-intent', signedIn), payload).then(results);

/*
 * Step 2: must be called after Stripe.js resolves (or after a redirect back).
 * Self-hosted → { status, booking }; partner flows → { status, booking_number, … }.
 * status: confirmed | processing | requires_payment_method | payment_failed | canceled | …
 * A failed partner reservation (already refunded) comes back as HTTP 400.
 */
export const verifySelfHostPayment = (bookingNumber) =>
  http.post(`api/v1/payments/verify-booking/${seg(bookingNumber)}`).then(results);

export const verifyHbdPayment = (bookingNumber) =>
  http.post(`api/v1/payments/verify-hbd-booking/${seg(bookingNumber)}`).then(results);

export const verifyBrevistayPayment = (bookingNumber) =>
  http.post(`api/v1/payments/verify-brevistay-booking/${seg(bookingNumber)}`).then(results);

/** Self-hosted booking details. Signed-in requests are checked for ownership. */
export const getSelfHostBooking = (bookingNumber, { signedIn = false } = {}) =>
  http
    .get(withAuth(`api/v1/payments/booking/${seg(bookingNumber)}`, signedIn))
    .then(results);

/** Bookings across the properties the signed-in host owns. { bookings, pagination } */
export const listHostBookings = ({ page = 1, limit = 20, hotelId } = {}) =>
  http
    .get('api/v1/payments/host-bookings', { params: { page, limit, hotelId: hotelId || undefined } })
    .then((r) => results(r) || { bookings: [], pagination: { page, limit, total: 0, totalPages: 0 } });
